import React, { useEffect } from 'react';
import { Circle, Transformer } from 'react-konva';

const CircleShape = ({ 
  id, 
  x, 
  y, 
  radius, 
  fill, 
  stroke, 
  strokeWidth, 
  draggable, 
  selected, 
  onSelect, 
  onChange, 
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  useEffect(() => {
    if (selected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  return (
    <>
      <Circle 
        ref={shapeRef}
        id={id}
        x={x} 
        y={y} 
        radius={radius} 
        fill={fill} 
        draggable={draggable}
        stroke={stroke}
        strokeWidth={strokeWidth}
        shadowBlur={selected ? 10 : 0} // Apply shadow effect when selected
        shadowColor={selected ? 'black' : null} // The shadow color when selected
        onDragEnd={e => {
          onChange({ id, type: 'circle', x: e.target.x(), y: e.target.y(), radius, fill, stroke, strokeWidth, draggable });
        }}
        onTransformEnd={() => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);

          onChange({
            id,
            type: 'circle',
            x: node.x(),
            y: node.y(),
            radius: Math.max(5, node.radius() * ((scaleX + scaleY) / 2)),
            fill,
            stroke,
            strokeWidth,
            draggable
          });
        }}
        onClick={onSelect}
        onTap={onSelect}
      />
      {selected && <Transformer ref={trRef} />}
    </>
  );
};

export default CircleShape;
